<template>
  <div>
    <base-header type="gradient-primary" class="pb-10 pb-8 pt-5 pt-md-8">
      <!-- Card stats -->
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <div class="card shadow">
            <datatable-header title="Users"/>
            <users-table :users="users" />
          </div>
        </div>
      </div>
    </div>

    <modal id="editUser" title="Edit User">
      <edit-user-form :user="editingUser" />
    </modal>
  </div>
</template>

<script>
import firebase from "@/config/firebase.js";

import DataTableHeader from "@/components/DataTable/DataTableHeader.vue";
import UsersTable from "@/views/users/components/UsersTable.vue";

import EditUserForm from "@/views/users/components/EditUserForm.vue";

import Modal from "@/components/Modal.vue";

export default {
  components: {
    "datatable-header": DataTableHeader,
    "users-table": UsersTable,
    "edit-user-form": EditUserForm,
    modal: Modal
  },
  data() {
    return {
      users: [],
      editingUser: {}
    };
  },
  computed: {
    orgId() {
      return this.$store.state.usermain.curOrg.id;
    }
  },
  watch: {
    orgId(newOrgId, _) {
      this.getUsers(newOrgId);
    }
  },
  mounted() {
    this.getUsers(this.orgId);
  },
  methods: {
    getUsers(curOrgId) {
      const self = this;

      firebase
        .firestore()
        .collection("organizations/" + curOrgId + "/users")
        .get()
        .then(function(querySnapshot) {
          const documents = querySnapshot.docs.map(doc => {
            const docData = doc.data();
            docData.id = doc.id;

            return docData;
          });

          self.users = documents;
        });
    }
  }
};
</script>
<style></style>
